import Button from '@components/Button';
import Column from '@components/Column';
import Text from '@components/Text';
import ModalContainer from '@modals/ModalContainer';
import { useFlow } from '@router/stackflow';
import { Modal } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation, Trans } from 'react-i18next';

interface Params {
    shopId: string;
}

const ShopPrepareModal: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
    const { shopId } = params;
    const { t } = useTranslation('shopPrepare');
    const { pop, push } = useFlow();
    const handleMove = () => {
        pop({ animate: false });
        push('ItemsActivity', { shopId, type: 'ALL' });
    };
    return (
        <Modal>
            <ModalContainer>
                <Column fullWidth align='center' spacing={36}>
                    <Text size='xl' align='center'>
                        <Trans ns="shopPrepare" i18nKey="message" components={{ br: <br /> }} />
                    </Text>
                    <Column fullWidth spacing={8}>
                        <Button fullWidth variant='secondary' onClick={pop}>{t('button.cancel')}</Button>
                        <Button fullWidth
                            onClick={handleMove} >
                            {t('button.viewMenu')}
                        </Button>
                    </Column>
                </Column>
            </ModalContainer>
        </Modal>
    );
};

export default ShopPrepareModal;
